import router from './router'
import store from '@/store/index'
import jwt from '@/jwt'
let entryUrl = null

/**
 * Check if route is public (doesn't require authentication)
 * @param {Object} to - Vue route object
 * @returns {boolean} - true if route is public
 */
function isPublicRoute(to) {
    return to.matched.some((record) =>
        record.meta.publicRegistration === true
    )
}

/**
 * Clear all authentication keys from localStorage and store
 * Used when navigating to public routes to ensure clean state
 */
function clearAuthState() {
    // Clear localStorage keys set by jwt.verify and auth flow
    localStorage.removeItem('vueauth_token')
    localStorage.removeItem('vueauth_token_expiry')
    localStorage.removeItem('user')
}

router.beforeEach(async (to, from, next) => {
    // Skip JWT verification for public routes (deeplink, document-upload)
    let verify = false
    let user = null

    if (isPublicRoute(to)) {
        // Clear any saved auth keys when navigating to public routes
        clearAuthState()
    } else {
        verify = await jwt.verify()
        if (store.getters.user && verify) {
            user = store.getters.user
        }
    }

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        /**
         * If the route requires a Auth User
         */
        if (!user) {
            /**
             * If the user is unauthenticated
             * redirect to login
             */
            entryUrl = to.path
            store.commit('setRedirectUrl', entryUrl)
            next({ name: 'login-page' })
        } else {
            //Check routes permission
            if (
                to.meta.permission &&
                to.meta.permission.length &&
                !!_.intersection(to.meta.permission, store.getters['scopes'])
                    .length
            ) {
                next()
            } else {
                if (to.meta.permission && to.meta.permission.length == 0) {
                    next()
                } else {
                    if (store.getters['scopes'].length) {
                        next({ name: store.getters['scopes'][0] })
                    } else {
                        next(new Error('403 Forbidden'))
                    }
                }
            }
        }
    } else if (to.matched.some((record) => record.meta.requiresGuest)) {
        /**
         * If the route requires a Guest User
         */
        if (user) {
            /**
             * If the user is authenticated
             * redirect to dashboard
             */
            next({ name: 'view-activity-dashboard' })
        } else {
            /**
             * Complete the user request normally
             */
            next()
        }
    } else {
        /**
         * Complete the user request normally
         */
        next()
    }
})

export default router
